// 劵库模块接口
import request from "@/utils/request";

export function couponsGroupList (data) {    //卷库列表
  return request({
    url: '/api/coupons/couponsGroup/list',
    method: 'POST',
    data: data,
  })
}

export function couponsGroupEnable (data) {    //券库启用/禁用
  return request({
    url: '/api/coupons/couponsGroup/enable',
    method: 'POST',
    data: data,
  })
}

export function couponsGroupCreate (data) {    //新建券库
  return request({
    url: '/api/coupons/couponsGroup/create',
    method: 'POST',
    data: data,
  })
}

export function couponsGroupDelete (data) {    //券库删除
  return request({
    url: '/api/coupons/couponsGroup/delete',
    method: 'POST',
    data: data,
  })
}

export function couponsGroupDetail (data) {    //券库详情
  return request({
    url: '/api/coupons/couponsGroup/detail',
    method: 'POST',
    data: data,
  })
}


export function couponsGroupOutappList (data) {    //创建券库--全部业务系统
  return request({
    url: '/api/coupons/couponsGroup/outappList',
    method: 'POST',
    data: data,
  })
}


export function couponsGroupSelectCategory (data) {    //创建券库--选择类别
  return request({
    url: '/api/coupons/couponsGroup/selectCategory',
    method: 'POST',
    data: data,
  })
}

export function couponsGroupSelectSelectLbl (data) {    //创建券库--选择类别标签
  return request({
    url: '/api/coupons/couponsGroup/selectLbl',
    method: 'POST',
    data: data,
  })
}

export function importExcelProduct (data) {    //导入产品编码,或者类别
  return request({
    url: '/api/coupons/importExcelProduct',
    method: 'POST',
    data: data,
    Headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function couponsGroupSelectLblLine (data) {    //创建券库--查看标签明细
  return request({
    url: '/api/coupons/couponsGroup/selectLblLine',
    method: 'POST',
    data: data
  })
}



export function productSelectProduct (data) {    //选择商品
  return request({
    url: '/api/product/selectProduct',
    method: 'POST',
    data: data
  })
}


export function couponsGroupUpdate (data) {    //券库修改
  return request({
    url: '/api/coupons/couponsGroup/update',
    method: 'POST',
    data: data
  })
}


export function reserveGIftlist (data) {    //礼物主数据列表
  return request({
    url: '/api/pointsmall/reserveGIft/list',
    method: 'POST',
    data: data
  })
}

export function otherIndustryCouponsList (data) {    //异业券库管理-券库管理--主页
  return request({
    url: '/api/coupons/couponsGroup/otherIndustryCouponsList',
    method: 'POST',
    data: data
  })
}


export function couponsImportCouponsExcel (data, parmars) {    //异业券库管理-导入未核销券
  return request({
    url: `/api/coupons/importCouponsExcel?couponsGrpID=${parmars.couponsGrpID}`,
    method: 'POST',
    data: data,
    Headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function importWriteOffCouponsExcel (data, parmars) {    //异业券库管理-导入未核销券
  return request({
    url: `/api/coupons/importWriteOffCouponsExcel?couponsGrpID=${parmars.couponsGrpID}`,
    method: 'POST',
    data: data,
    Headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function otherIndustryWriteOff (data) {    //异业券库管理-券库管理--核销
  return request({
    url: `/api/coupons/couponsGroup/otherIndustryWriteOff`,
    method: 'POST',
    data: data
  })
}


export function otherIndustryDisable (data) {    //异业券库管理-券库管理--禁用
  return request({
    url: `/api/coupons/couponsGroup/otherIndustryDisable`,
    method: 'POST',
    data: data
  })
}

export function couppacketList (data) {    //券包列表
  return request({
    url: `/api/coupons/couppacket/list`,
    method: 'POST',
    data: data
  })
}


export function couppacketInsert (data, coupPacketName) {    //新建券包
  return request({
    url: `/api/coupons/couppacket/insert?coupPacketName=${coupPacketName}`,
    method: 'POST',
    data: data
  })
}

export function couppacketenable (data) {    //新建券包
  return request({
    url: `/api/coupons/couppacket/enable`,
    method: 'POST',
    data: data
  })
}


export function couppacketdelete (data) {    //券包删除
  return request({
    url: `/api/coupons/couppacket/delete`,
    method: 'POST',
    data: data
  })
}

export function couppacketview (data) {    //券包查看
  return request({
    url: `/api/coupons/couppacket/view`,
    method: 'POST',
    data: data
  })
}

export function couppacketupdate (data, coupPacketID, coupPacketName) {    //券包查看
  return request({
    url: `/api/coupons/couppacket/update?coupPacketID=${coupPacketID}&coupPacketName=${coupPacketName}`,
    method: 'POST',
    data: data
  })
}


export function couponslist (data) {    //已发券管理列表
  return request({
    url: `/api/coupons/list`,
    method: 'POST',
    data: data
  })
}


export function queryByCoupID (data) {    //查询
  return request({
    url: `/api/coupons/queryByCoupID`,
    method: 'POST',
    data: data
  })
}


export function couponsverity (data) {    //手工核销
  return request({
    url: `/api/coupons/verity`,
    method: 'POST',
    data: data
  })
}


export function couponsdisable (data) {    //禁用
  return request({
    url: `/api/coupons/disable`,
    method: 'POST',
    data: data
  })
}

export function TApiLogsyncProcess (data) {
  return request({
    url: "/api/tApiLog/syncProcess",
    method: 'POST',
    data: data,

  })
}